import React from "react";
import * as PropTypes from "prop-types";
import { methods } from "../../../constants";
import styleConstants from "../../../styleConstants";
import StackedColumnChart from "../../chart/StackedColumnChart";

const MethodMixChart = props => {
  const data = props.data;

  return (
    <div>
      <StackedColumnChart
        ref={props.innerRef}
        height={styleConstants.stackedBarHeight}
        categories={["LIC", "L-MIC", "U-MIC"]}
        series={methods.map(method => ({
          name: method,
          color: styleConstants.categoryColors.methodColors[method],
          data: data
            .filter(datum => datum.method === method)
            .map(datum => datum.value)
        }))}
        reversedLegend={true}
        absolute={props.absolute}
        tooltipFormatter={props.tooltipFormatter}
      />
    </div>
  );
};

MethodMixChart.propTypes = {
  data: PropTypes.array.isRequired,
  absolute: PropTypes.bool,
  tooltipFormatter: PropTypes.func
};

export default React.forwardRef((props, ref) => (
  <MethodMixChart innerRef={ref} {...props} />
));
